export const NA = "Not available";

export const dateLabel = (value: string | null) => {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? value
    : date.toLocaleDateString("en-IN", { month: "short", year: "numeric" });
};

export const fullDateLabel = (value: string | null) =>
  value
    ? new Date(value).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "";

export const money = (value: number | null, printed: string | null) => {
  if (printed) return printed.startsWith("$") ? printed : `$${printed}`;
  if (value === null) return NA;
  if (value >= 1_000_000_000) return `$${(value / 1_000_000_000).toFixed(1)}B`;
  if (value >= 1_000_000) return `$${(value / 1_000_000).toFixed(1)}M`;
  if (value >= 1_000) return `$${(value / 1_000).toFixed(1)}K`;
  return `$${value}`;
};

export const titleCase = (value: string) =>
  value.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export const inr = (value: number | null, currency: string | null = "INR") =>
  value === null || value === undefined
    ? "--"
    : new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: currency || "INR",
        maximumFractionDigits: 2,
      }).format(value);

export const compactInr = (value: number | null, currency: string | null = "INR") => {
  if (value === null || value === undefined) return "--";
  const abs = Math.abs(value);
  const fmt = (n: number) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: currency || "INR",
      maximumFractionDigits: 2,
    }).format(n);
  if (abs >= 1e7) return `${fmt(value / 1e7)} Cr`;
  if (abs >= 1e5) return `${fmt(value / 1e5)} L`;
  return fmt(value);
};

export const ratio = (value: number | null | undefined) =>
  value === null || value === undefined ? "--" : value.toFixed(2);

export const percent = (value: number | null | undefined, alreadyPercent = false) =>
  value === null || value === undefined
    ? "--"
    : `${(alreadyPercent ? value : value * 100).toFixed(2)}%`;
